import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

// AsyncThunk to fetch purchase list
export const get_purchase_list = createAsyncThunk(
  "purchase/getpurchaseList",
  async (data, thunkAPI) => {
    try {
      const body = new FormData();
      body.append("userid", "1");
      body.append("ingress", "1");
      body.append("action", "list");
      body.append("page", data.page.toString());
      body.append("limit", data.rows.toString());

      const response = await fetch(`${baseUrl}purchase.php`, {
        method: "POST",
        body,
      });

      const res = await response.json();
      console.log("res", res);

      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch purchase list.");
    }
  }
);

// Initial state
const initialState = {
  purchase_list: [],
  loading: false,
  total_purchase_count: 0,
};

// Slice
const purchaseSlice = createSlice({
  name: "purchase",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_purchase_list.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(get_purchase_list.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(get_purchase_list.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      console.log("purchase here");

      state.loading = false;
      if (data.success) {
        state.total_purchase_count = data.totalcount;
        state.purchase_list = data.data;
      } else {
        state.purchase_list = [];
      }
    });
  },
});

export default purchaseSlice.reducer;
